/**
 * Nearest ancestor that scrolls (overflow auto/scroll/overlay).
 * Used so the virtualizer can attach to the sidebar scroller without owning it.
 */
export function getScrollParent(element: HTMLElement | null): HTMLElement | null {
  if (!element) return null;

  let parent = element.parentElement;
  while (parent) {
    const { overflow, overflowY } = getComputedStyle(parent);
    if (/(auto|scroll|overlay)/.test(`${overflow}${overflowY}`)) {
      return parent;
    }
    parent = parent.parentElement;
  }

  return null;
}
